import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1.125em",
	height: "1.125em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20 12C20 8.39285 19.5252 6.53883 18.4932 5.50684C17.4612 4.47484 15.6071 4 12 4C8.39285 4 6.53883 4.47484 5.50684 5.50684C4.47484 6.53883 4 8.39285 4 12C4 15.6071 4.47484 17.4612 5.50684 18.4932C6.53883 19.5252 8.39285 20 12 20C15.6071 20 17.4612 19.5252 18.4932 18.4932C19.5252 17.4612 20 15.6071 20 12ZM12 11C12.5523 11 13 11.4477 13 12V15C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H12C11.4477 17 11 16.5523 11 16V13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H12ZM12.0098 8C12.5621 8 13.0098 8.44772 13.0098 9C13.0098 9.55228 12.5621 10 12.0098 10H12C11.4477 10 11 9.55228 11 9C11 8.44772 11.4477 8 12 8H12.0098ZM22 12C22 15.5929 21.5752 18.2392 19.9072 19.9072C18.2392 21.5752 15.5929 22 12 22C8.40715 22 5.76078 21.5752 4.09277 19.9072C2.42477 18.2392 2 15.5929 2 12C2 8.40715 2.42477 5.76078 4.09277 4.09277C5.76078 2.42477 8.40715 2 12 2C15.5929 2 18.2392 2.42477 19.9072 4.09277C21.5752 5.76078 22 8.40715 22 12Z",
		fill: "currentColor"
	})
});
export default SvgInfo;
